import React from 'react';
import classNames from 'classnames';

import 'components/hearts/hearts.scss';
import DataStore from '../../containers/store/DataStore';

interface IDataStore {
  dataStore?: DataStore;
}
interface inputProps {
  onChange?: (value: number) => void;
  defaultValue?: number;
}

const defaultProps: inputProps = {
  defaultValue: 10
};

const Hearts: React.SFC<inputProps & IDataStore> = ({
  onChange,
  defaultValue
}) => {
  let value = defaultValue !== -1 ? defaultValue : 5;
  return (
    <div className={classNames('c-hearts')}>
      <div
        className={classNames('c-hearts__item c-hearts__item-' + value)}
        onClick={() => {
          if (value < 10) {
            value++;
            onChange(value);
          }
        }}
      >
        decrease heart value {10 - value}
      </div>
      <div
        className={classNames('c-hearts__item c-hearts__item-' + (10 - value))}
        onClick={() => {
          if (value > 0) {
            value--;
            onChange(value);
          }
        }}
      >
        decrease heart value {value}
      </div>
    </div>
  );
};

Hearts.defaultProps = defaultProps;

export default Hearts;



// WEBPACK FOOTER //
// ./src/components/hearts/hearts.tsx